import { apiSlice } from '../../app/apiSlice';
import { Usuario, UsuarioDTO } from '../../types/usuario/Usuario';
import { UsuarioAddRemoveSetorDTO, UsuarioList } from '../../types/usuario/UsuarioList';
import configSiteUrls from '../site/configs/configSiteUrls';

const endpointUrl = configSiteUrls.SITE_USUARIO_EP;

function createUsuario(obj: Usuario) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function addSetorUsuario(obj: UsuarioAddRemoveSetorDTO[]) {
  return {
    url: `${endpointUrl}/add-setor`,
    method: 'POST',
    body: obj
  };
}

function deleteSetorUsuario(obj: UsuarioAddRemoveSetorDTO[]) {
  return {
    url: `${endpointUrl}/remove-setor`,
    method: 'POST',
    body: obj
  };
}

function updateUsuario(obj: Usuario) {
  return {
    url: `${endpointUrl}/${obj.id}`,
    method: 'PUT',
    body: obj
  };
}

function deleteUsuario({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}

function getUsuarios({ search }: { search: string }) {
  return {
    url: `${endpointUrl}/filter?search=${search}`,
    method: 'GET'
  };
}

function addUsuario(obj: UsuarioDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function getUsuario(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  }

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}

export const usuarioApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getUsuarios: query<UsuarioList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getUsuarios,
      providesTags: ['Usuario']
    }),
    getUsuario: query<Usuario, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getUsuario,
      providesTags: ['Usuario']
    }),
    addUsuario: mutation<void, UsuarioDTO>({
      query: addUsuario,
      invalidatesTags: ['Usuario']
    }),

    createUsuario1: mutation<Usuario, Usuario>({
      query: createUsuario,
      invalidatesTags: ['Usuario']
    }),
    addSetorUsuario: mutation<void, UsuarioAddRemoveSetorDTO[]>({
      query: addSetorUsuario,
      invalidatesTags: ['Usuario']
    }),

    deleteSetorUsuario: mutation<void, UsuarioAddRemoveSetorDTO[]>({
      query: deleteSetorUsuario,
      invalidatesTags: ['Usuario']
    }),

    createUsuario: mutation<Usuario, Usuario>({
      query: obj => ({
        url: `${endpointUrl}/create`, // Usando a variável endpointUrl diretamente
        method: 'POST', // Método POST para criar o usuario
        body: obj // Corpo da requisição com os dados do novo usuario
      }),
      invalidatesTags: ['Usuario']
    }),

    changePasswordUsuario: mutation<void, { id: string; newPassword: string; oldPassword: string }>({
      query: ({ id, newPassword, oldPassword }) => ({
        url: `${endpointUrl}/change-password`, // Usando a variável endpointUrl diretamente
        method: 'POST', // Método POST para criar o usuario
        body: {
          id,
          senhaNova: newPassword,
          senhaAntiga: oldPassword
        } // Corpo da requisição com os dados do novo usuario
      }),
      invalidatesTags: ['Usuario']
    }),

    updateUsuario: mutation<Usuario, Usuario>({
      query: updateUsuario,
      invalidatesTags: ['Usuario']
    }),

    deleteUsuario: mutation<Usuario, { id: string }>({
      query: deleteUsuario,
      invalidatesTags: ['Usuario']
    })
  })
});
export const {
  useGetUsuarioQuery,
  useGetUsuariosQuery,
  useCreateUsuarioMutation,
  useUpdateUsuarioMutation,
  useDeleteUsuarioMutation,
  useCreateUsuario1Mutation,
  useAddUsuarioMutation,
  useChangePasswordUsuarioMutation,
  useDeleteSetorUsuarioMutation,
  useAddSetorUsuarioMutation
} = usuarioApiSlice;
